<template>
  <div>
    <accordion-component>
      <template v-slot:header>
        {{ $t('W2P_RECIPIENTS_HOW_TO_TITLE') }}
      </template>
      <template v-slot:content>
        <div class="container-content">
          <div class="container-description">
            {{
              $t('W2P_RECIPIENTS_HOW_TO_DESCRIPTION', {
                count: headers.length
              })
            }}
          </div>
          <div
            class="pn-table-cont"
            :class="{ 'hide-scroll-els': intersecting }"
          >
            <p class="tiny scroll-text">
              {{ $t('W2P_RECIPIENTS_SCROLL_TEXT') }}
              <pn-icon
                symbol="arrow-right"
                color="gray700"
                size="medium"
                solid
              ></pn-icon>
            </p>
            <pn-table bordered>
              <table>
                <div class="table-body-container">
                  <thead>
                    <tr>
                      <th
                        v-for="(header, index) in headers"
                        :key="`header-${index}`"
                      >
                        {{ header }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        v-for="(sample, index) in samples"
                        :key="`sample-${index}`"
                      >
                        {{ sample }}
                      </td>
                    </tr>
                  </tbody>
                </div>
                <observer @change="intersecting = $event.intersecting" />
              </table>
            </pn-table>
          </div>
          <div class="download-button-container">
            <pn-button-container size="medium">
              <button @click="downloadFile('samples', 'xlsx')">
                {{ $t('W2P_RECIPIENT_DOWNLOAD_XLSX_TEMPLATE') }}
                <pn-icon
                  symbol="download"
                  color="white"
                  size="small"
                  solid
                ></pn-icon>
              </button>
            </pn-button-container>
          </div>
        </div>
      </template>
    </accordion-component>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'

import AccordionComponent from '@/components/common/accordion/AccordionComponent'
import Observer from '@/components/Observer'

export default {
  components: {
    AccordionComponent,
    Observer
  },
  data() {
    return {
      intersecting: false,
      table: []
    }
  },
  computed: {
    ...mapState(['market', 'lang']),
    ...mapState('letter/upload', ['letterOptions']),
    service() {
      return this.letterOptions.includePaymentSlip
        ? 'paymentSlips'
        : 'information'
    },
    headers() {
      return this.table.map(item => {
        return item.name[this.lang]
      })
    },
    samples() {
      return this.table.map(item => {
        return item.sample[this.lang]
      })
    }
  },
  mounted() {
    axios({
      method: 'get',
      url: `${process.env.VUE_APP_W2P_API_BASE_URL}/recipients/v2/getSampleColumns?service=${this.service}&market=${this.market}`
    }).then(response => {
      this.table = response.data.result
    })
  },
  methods: {
    downloadFile(type, ext) {
      this.$emit('downloadFile', { type, ext })
    }
  }
}
</script>

<style lang="scss" scoped>
.container-content {
  button {
    width: 16em;
    &:first-child {
      margin-right: 1em;
    }
  }
  .container-description {
    color: $black;
  }
  table {
    display: flex;
    overflow-x: auto;
    white-space: nowrap;
    width: fit-content;
  }
}

.pn-table-container {
  position: relative;
  display: flex;

  &:after {
    content: '';
    position: absolute;
    height: 100%;
    width: 2em;
    right: 0;
    top: 0;
    transition: opacity 0.1s ease-in-out;
    background: linear-gradient(
      to left,
      rgba(255, 255, 255, 1),
      rgba(255, 255, 255, 0.1)
    );
    opacity: 1;
  }
}

pn-table .pn-table-container table thead tr th {
  color: $black;
}

.scroll-text {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 0.5em 0;
  width: 100%;
  opacity: 1;
  transition: opacity 0.1s ease-in-out;
  color: $gray700;
}

.pn-table-cont.hide-scroll-els {
  .scroll-text {
    opacity: 0;
  }

  .pn-table-container:after {
    opacity: 0;
  }
}

@media screen and (max-width: 65em) {
  .download-button-container {
    pn-button-container {
      width: 100%;

      button {
        min-width: 100%;
      }

      button:first-of-type {
        margin-bottom: 1em;
      }
    }
  }
}
</style>
